import { MembershipsSpotifyIntegrationsApiClient } from '@fourthwall/services/dist/MembershipsSpotifyIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const usePodcastQuery = createQueryHook(MembershipsSpotifyIntegrationsApiClient.getPodcast, {
  queryKey: ['podcast'],
})
